import { asMultiStyleConfig } from '../../../../utils/theme';
var parts = ['container', 'footer'];
var baseStyle = () => ({
  container: {
    borderRadius: '0.25rem'
  },
  footer: {
    pt: {
      base: 0,
      md: 8
    },
    pb: {
      base: 3,
      md: 8
    },
    px: {
      base: 5,
      sm: 6,
      md: 10
    },
    bg: {
      base: 'transparent',
      md: 'grey.200'
    },
    borderTop: '1px solid',
    borderTopColor: {
      base: 'transparent',
      md: 'grey.250'
    },
    borderBottomRadius: '0.25rem'
  }
});
export var Card = asMultiStyleConfig({
  parts,
  baseStyle
});